import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../styles/pages.css';

const ViewAllVideos = () => {
  const navigate = useNavigate();
  const { courseId } = useParams();
  const [videos, setVideos] = useState([]);

  // Mock course videos data (same as demo.html)
  const mockVideos = useCallback(() => ({
    'course_1': [
      { id: 1, title: 'Introduction to HTML5', duration: '15 mins', thumbnail: 'https://via.placeholder.com/400x300?text=HTML5' },
      { id: 2, title: 'CSS Basics & Styling', duration: '18 mins', thumbnail: 'https://via.placeholder.com/400x300?text=CSS' },
      { id: 3, title: 'JavaScript Fundamentals', duration: '22 mins', thumbnail: 'https://via.placeholder.com/400x300?text=JavaScript' },
      { id: 4, title: 'DOM Manipulation', duration: '20 mins', thumbnail: 'https://via.placeholder.com/400x300?text=DOM' },
      { id: 5, title: 'Events & Listeners', duration: '19 mins', thumbnail: 'https://via.placeholder.com/400x300?text=Events' },
      { id: 6, title: 'Async Programming', duration: '25 mins', thumbnail: 'https://via.placeholder.com/400x300?text=Async' },
      { id: 7, title: 'ES6 Features', duration: '23 mins', thumbnail: 'https://via.placeholder.com/400x300?text=ES6' },
      { id: 8, title: 'Modules & Imports', duration: '17 mins', thumbnail: 'https://via.placeholder.com/400x300?text=Modules' },
    ]
  }), []);

  useEffect(() => {
    // Load videos for current course
    const courseVideos = mockVideos()[courseId] || mockVideos()['course_1'];
    setVideos(courseVideos);
  }, [courseId, mockVideos]);

  const playVideo = (videoId, videoTitle) => {
    // In a real app, this would open a video player
    alert(`Playing: ${videoTitle}`);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#ffffff', padding: '2rem 0' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', marginBottom: '3rem' }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              width: '40px',
              height: '40px',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '6px',
              background: '#1a1a1a',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 300ms ease',
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#2d2d2d';
              e.target.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.target.style.background = '#1a1a1a';
              e.target.style.transform = 'scale(1)';
            }}
          >
            <i className="fas fa-arrow-left"></i>
          </button>
          <div>
            <h1 style={{ fontSize: '2.5rem', margin: '0 0 0.5rem 0', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-1px' }}>
              All Course Videos
            </h1>
            <p style={{ color: '#666', margin: 0, fontSize: '1rem' }}>
              Complete collection of course video lessons
            </p>
          </div>
        </div>

        {/* Videos Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '1.5rem',
        }}>
          {videos.map((video) => (
            <div
              key={video.id}
              onClick={() => playVideo(video.id, video.title)}
              onMouseOver={(e) => {
                e.currentTarget.style.boxShadow = '0 12px 24px rgba(0, 0, 0, 0.1)';
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
              style={{
                background: '#f9f9f9',
                border: '1px solid #e8e8e8',
                borderRadius: '8px',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'all 300ms ease',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
              }}
            >
              {/* Video Thumbnail */}
              <div style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                height: '160px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '3rem',
                position: 'relative',
              }}>
                <i className="fas fa-play-circle"></i>
                <div style={{
                  position: 'absolute',
                  bottom: '0.5rem',
                  right: '0.5rem',
                  background: '#B8860B',
                  color: 'white',
                  padding: '0.25rem 0.75rem',
                  borderRadius: '4px',
                  fontSize: '0.75rem',
                  fontWeight: '700',
                }}>
                  {video.duration}
                </div>
              </div>

              {/* Video Info */}
              <div style={{ padding: '1.5rem' }}>
                <h3 style={{
                  fontWeight: 700,
                  fontSize: '1rem',
                  margin: '0 0 1rem 0',
                  color: '#1a1a1a',
                }}>
                  {video.title}
                </h3>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#7A5107',
                  fontSize: '0.9rem',
                }}>
                  <i className="fas fa-clock"></i>
                  <span>{video.duration}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ViewAllVideos;
